import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "zoomgroom-p01.firebaseapp.com",
  projectId: "zoomgroom-p01",
  storageBucket: "zoomgroom-p01.firebasestorage.app",
  messagingSenderId: "1043507354142",
  appId: "1:1043507354142:web:08478ea13913faed5b2c0f",
  measurementId: "G-GN25MBTFPN"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { app, auth, analytics};
